module.exports = __webpack_public_path__ + "files/9f7d92c249afdbe7e6f969bf3d7dc38f.png";